module.exports = __webpack_public_path__ + "static/media/logo-dark.9f3c44fc.svg";